export enum PageState {
    InitialState,
    ErrorState,
    LoadingState,
    SuccessState
}
